// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useRequest } from "redux-query-react";
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import * as QueryString from 'query-string';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { CashflowFromJSON, TaModelFromJSON, } from '../models';
/**
 * Generating cashflows from specific Takahashi-Alexander Forecast Model Parameters
 * Get cashflows for TA model parameters
 */
export function getCashflowsFromTamodelParametersRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.bow === null || requestParameters.bow === undefined) {
        throw new runtime.RequiredError('bow', 'Required parameter requestParameters.bow was null or undefined when calling getCashflowsFromTamodelParameters.');
    }
    if (requestParameters.lifetime === null || requestParameters.lifetime === undefined) {
        throw new runtime.RequiredError('lifetime', 'Required parameter requestParameters.lifetime was null or undefined when calling getCashflowsFromTamodelParameters.');
    }
    if (requestParameters.minDistributionRate === null || requestParameters.minDistributionRate === undefined) {
        throw new runtime.RequiredError('minDistributionRate', 'Required parameter requestParameters.minDistributionRate was null or undefined when calling getCashflowsFromTamodelParameters.');
    }
    if (requestParameters.growthRate === null || requestParameters.growthRate === undefined) {
        throw new runtime.RequiredError('growthRate', 'Required parameter requestParameters.growthRate was null or undefined when calling getCashflowsFromTamodelParameters.');
    }
    if (requestParameters.contributionRates === null || requestParameters.contributionRates === undefined) {
        throw new runtime.RequiredError('contributionRates', 'Required parameter requestParameters.contributionRates was null or undefined when calling getCashflowsFromTamodelParameters.');
    }
    if (requestParameters.commitment === null || requestParameters.commitment === undefined) {
        throw new runtime.RequiredError('commitment', 'Required parameter requestParameters.commitment was null or undefined when calling getCashflowsFromTamodelParameters.');
    }
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.bow !== undefined) {
        queryParameters['bow'] = requestParameters.bow;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.lifetime !== undefined) {
        queryParameters['lifetime'] = requestParameters.lifetime;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.minDistributionRate !== undefined) {
        queryParameters['minDistributionRate'] = requestParameters.minDistributionRate;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.growthRate !== undefined) {
        queryParameters['growthRate'] = requestParameters.growthRate;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.contributionRates) {
        queryParameters['contributionRates'] = requestParameters.contributionRates;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.commitment !== undefined) {
        queryParameters['commitment'] = requestParameters.commitment;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/cff/ta-cashflows` + queryString,
        meta,
        update: requestConfig.update || {
            TAModels: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(CashflowFromJSON);
            return {
                TAModels: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetCashflowsFromTamodelParameters-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Generating cashflows from specific Takahashi-Alexander Forecast Model Parameters
* Get cashflows for TA model parameters
*/
export function getCashflowsFromTamodelParameters(requestParameters, requestConfig) {
    return getCashflowsFromTamodelParametersRaw(requestParameters, requestConfig);
}
/**
 * retreieve all TA models using GET
 * Get all ta models
 */
export function getTaModelsRaw(requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/tamodels` + queryString,
        meta,
        update: requestConfig.update || {
            TAModels: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(TaModelFromJSON);
            return {
                TAModels: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetTaModels`;
    return config;
}
/**
* retreieve all TA models using GET
* Get all ta models
*/
/**
 * Use this selectors to get a record of all Array<TaModel>, with their ids as keys
 * @returns A record of Array<TaModel> object, with their ids as keys
 */
export const useTAModelsRecordSelector = () => useSelector((state) => state.entities.TAModels, isEqual);
const TAModelsArraySelector = createSelector((state) => state.entities.TAModels, (selectedSubState) => Object.keys(selectedSubState).map((id) => selectedSubState[id]));
/**
 * Use this selector to get a reference to a flat Array<TaModel>.
 * If you are doing transformation on this object, consider using useTAModelsRecordSelector instead for performances
 * @returns An array containing all loaded TAModels
 */
export const useTAModelsArraySelector = () => useSelector(TAModelsArraySelector, isEqual);
/**
 * Request hook for Array<TaModel>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns an array containg the data, query status, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetTaModels = (customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getTaModelsRaw(customQueryConfig));
    return [
        useTAModelsArraySelector(),
        querystate,
        forceRefresh
    ];
};
export function getTaModels(requestConfig) {
    return getTaModelsRaw(requestConfig);
}
